import { z } from 'zod';

export enum ExploreStatisticsFileType {
  CSV = 'csv',
}

export const exploreStatisticsFileTypeSchema = z.enum(ExploreStatisticsFileType);
